import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("cardlon_token");
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export function formatApiError(detail) {
  if (detail == null) return "Etwas ist schiefgelaufen. Bitte erneut versuchen.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  if (detail && typeof detail.error === "string") return detail.error;
  if (detail && typeof detail.message === "string") return detail.message;
  return String(detail);
}

// Robust error extractor for axios responses — falls back to status / network errors.
export function extractApiError(err) {
  // Network / CORS / offline
  if (!err?.response) {
    if (err?.code === "ERR_NETWORK") return "Netzwerkfehler – Server nicht erreichbar.";
    if (err?.message) return err.message;
    return "Etwas ist schiefgelaufen. Bitte erneut versuchen.";
  }
  const { status, data } = err.response;
  // Rate limit handler from slowapi returns {"error": "..."} not {"detail": ...}
  if (status === 429) {
    const msg = (data && (data.error || data.detail)) || "Zu viele Versuche. Bitte später erneut versuchen.";
    return typeof msg === "string" ? msg : "Zu viele Versuche. Bitte später erneut versuchen.";
  }
  if (status === 503) {
    const msg = data?.detail || data?.error || data?.message;
    return typeof msg === "string" ? msg : "Service vorübergehend nicht verfügbar (503).";
  }
  if (data?.detail !== undefined) return formatApiError(data.detail);
  if (data?.error !== undefined) return formatApiError(data.error);
  if (data?.message !== undefined) return formatApiError(data.message);
  if (typeof data === "string" && data.trim()) return data;
  return `Fehler ${status}. Bitte erneut versuchen.`;
}

export function resolveImageUrl(url) {
  if (!url) return null;
  if (url.startsWith("http://") || url.startsWith("https://")) return url;
  if (url.startsWith("/api/")) return `${BACKEND_URL}${url}`;
  return url;
}
